var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 170,
    viewBox: "0 0 285 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.987 41.1038C139.591 41.2779 137.33 42.2284 135.613 43.7982L59.2017 114.224C48.405 98.2744 43.2393 79.6321 44.4162 60.8645C45.593 42.0969 53.0546 24.1273 65.7731 9.43064L73.669 0.650937L19.1113 0.650931L17.9906 2.48199C7.0142 20.8854 0.955924 41.4353 0.318069 62.4278C-0.319786 83.4202 4.48116 104.25 14.3228 123.191L14.6285 123.755C19.203 132.357 24.7708 140.479 31.2352 147.981C37.4357 154.609 44.0704 160.88 51.1022 166.761C52.9889 168.385 55.4741 169.288 58.0556 169.288C60.6371 169.288 63.1223 168.385 65.009 166.761L142.34 94.7884L219.672 166.761C221.559 168.385 224.044 169.288 226.625 169.288C229.207 169.288 231.692 168.385 233.579 166.761C240.61 160.88 247.245 154.609 253.446 147.981C259.91 140.479 265.478 132.357 270.052 123.755L270.358 123.191C280.2 104.25 285.001 83.4202 284.363 62.4278C283.725 41.4353 277.667 20.8854 266.69 2.48199L265.57 0.65091L211.012 0.650931L218.908 9.43064C231.626 24.1273 239.088 42.0969 240.265 60.8645C241.442 79.6321 236.276 98.2744 225.479 114.224L149.068 43.7982C147.351 42.2284 145.09 41.2779 142.694 41.1038L142.694 41.0751C142.576 41.0761 142.458 41.079 142.341 41.0838C142.223 41.079 142.105 41.0761 141.987 41.0751L141.987 41.1038Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeft);
export default __webpack_public_path__ + "static/media/logo-left.2c9768716864ea83afca3834ac5ca4a6.svg";
export { ForwardRef as ReactComponent };